import {breakpoints} from "@next/ux-fabric"
import {styled} from "@mui/material/styles"

export const MenuItemCountryFlagImg = styled("img")`
    height: 1.5rem;
    width: 1.5rem;

    @media (min-width: ${breakpoints.values.lg}px) {
        height: 1.25rem;
        width: 1.25rem;
    }
`

export default MenuItemCountryFlagImg
